import React from "react";
import styles from "./ToolUse.scss";
import { Icon } from "../../../../graphic/Icon";
import { PaperDocList } from "../PaperDocList/PaperDocList";
import { PaperDocPreview } from "../PaperDocPreview/PaperDocPreview";

// Rendered from assistant-ui's part registry for tool-call parts. The runtime
// part shape ({ toolName, args, result }) is produced by convertUiMessage
// from the AI SDK dynamic-tool parts; `result` is the completed output.
export const ToolUse = ({ part }) => {
    let specific = null;
    switch (part.toolName) {
        case "find_paperdoc":
            specific = <PaperDocList documents={part.result} />;
            break;
        case "get_paperdoc_body":
            specific = <PaperDocPreview document={part.result} />;
            break;
        default:
            break;
    }

    return (
        <div className={styles.base}>
            <div className={styles.tool}>
                <Icon name="tools" /> {part.toolName}
            </div>
            {specific ? <div className={styles.specific}>{specific}</div> : null}
        </div>
    );
};
